/*
 * @Author: chendz7
 * @Date: 2019-03-02 10:46:34
 */
export default {
    tagsView: {
        refresh: '刷新',
        closeOthers: '关闭其他',
        closeAll: '关闭所有',
        close: '关闭'
    },
    route: {
        index: '首页',
        tableSort: '表头排序',
        batchOperation: '批量操作',
        editableTable: '可编辑表格',
        menuShrink: '菜单收缩',
        importAndExport: '导入导出',
        import: '导入',
        export: '导出',
        progress: '下载进度条',
        dictionary: '数据字典',
        mPanel: '常用面板',
        mPanel1: '常用面板1',
        mPanel2: '常用面板2',
        mPanel3: '常用面板3',
        notFound: '404',
        columns: '可配置列',
        filters: '列筛选',
        oss: 'OSS示例',
        report: '自定义内嵌报表'
    },
    home: {

    },
    developer: {
        message: '你好，开发者页面！'
    }
};
